import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	Output,
	ViewChild
} from '@angular/core';

@Component({
	selector: 'show-more-content',
	template: require('./show-more-content.component.html'),
	styles: [require('./show-more-content.component.scss')]
})
export class ShowMoreContentComponent implements AfterViewInit {
	@Input('content') content: string;
	@Output('emitShowMoreModal') emitShowMoreModal = new EventEmitter();
	@ViewChild('description') description: ElementRef;
	showMoreFlag = false;
	maxHeight = 355; // Default value
	currentHeight: number;
	addGradient: boolean;
	label = 'SHOW MORE';

	constructor() {}

	ngAfterViewInit() {
		this.currentHeight = this.description.nativeElement.offsetHeight;
		this.addGradient = this.currentHeight >= this.maxHeight;
	}

	showMoreHandler() {
		this.showMoreFlag = !this.showMoreFlag;
		// this.label = this.showMoreFlag ? 'SHOW LESS' : 'SHOW MORE';
		this.emitShowMoreModal.emit();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/show-more-content/show-more-content.component.ts